import { render } from "./NativeInfoModal.vue?vue&type=template&id=bd1226f4&ts=true"
import script from "./NativeInfoModal.vue?vue&type=script&lang=ts"
export * from "./NativeInfoModal.vue?vue&type=script&lang=ts"

import "./NativeInfoModal.vue?vue&type=style&index=0&id=bd1226f4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__